import { Divider, Spin, Button } from 'antd'
import React from 'react'
import { useHistory } from 'react-router-dom'

const VariableDisplay = ({ title, data, loading }) => {
  const history = useHistory()
  const isDatasetView = title === 'Dataset Parameters'

  const viewTableModal = (param) => {
    const queryParams = new URLSearchParams()
    queryParams.set('tableId', param.Argument.id)
    history.push({
      search: `?${queryParams.toString()}`
    })
  }

  const paramToView = (param) => {
    switch (param.Argument?.type) {
      case 'ImageIdentifier':
        return <img className='w-20' src={param.Argument?.value} alt={param.Name} />
      case 'Table':
        return (
          <Button type='link' className='text-sm p-0 pl-0 flex content-start' onClick={() => viewTableModal(param)}>
            &lt;Table&gt;
          </Button>
        )
      default:
        return param.Argument?.value
    }
  }

  return (
    <>
      <p className='text-md font-bold'>{title}</p>
      <div className='flex flex-col gap-y-3'>
        <Divider className='my-0' />
        <Spin spinning={loading} size='small'>
          {data.length > 0 ? (
            <div className='flex flex-col gap-y-3'>
              {data.map((param) => (
                <div className='grid grid-cols-2 md:grid-cols-3 p-0 gap-x-10'>
                  <span className='font-semibold break-all md:col-span-1'>
                    {isDatasetView ? param.Id : param.Name}
                  </span>
                  <span
                    className={`${param.Argument?.type === 'Secret' && 'text-gray-400 select-none'} break-all md:col-span-2`}
                  >
                    {paramToView(param)}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p className='italic text-gray-300'>{isDatasetView ? 'No Parameters' : 'No Variables'}</p>
          )}
        </Spin>
      </div>
    </>
  )
}

export default VariableDisplay
